// extracted by mini-css-extract-plugin
export default {"GitHub":"Footer_GitHub__eQe+H","VK":"Footer_VK__ewtE1"};